/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InovalonPayer
 */
export interface InovalonPayer {
    /**
     * 
     */
    PayerIdentifierNumber: string;
    /**
     * 
     */
    PayerName: string;
}

/**
 * Check if a given object implements the InovalonPayer interface.
 */
export function instanceOfInovalonPayer(value: object): value is InovalonPayer {
    if (!('PayerIdentifierNumber' in value) || value['PayerIdentifierNumber'] === undefined) return false;
    if (!('PayerName' in value) || value['PayerName'] === undefined) return false;
    return true;
}

export function InovalonPayerFromJSON(json: any): InovalonPayer {
    return InovalonPayerFromJSONTyped(json, false);
}

export function InovalonPayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): InovalonPayer {
    if (json == null) {
        return json;
    }
    return {
        
        'PayerIdentifierNumber': json['PayerIdentifierNumber'],
        'PayerName': json['PayerName'],
    };
}

export function InovalonPayerToJSON(json: any): InovalonPayer {
    return InovalonPayerToJSONTyped(json, false);
}

export function InovalonPayerToJSONTyped(value?: InovalonPayer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'PayerIdentifierNumber': value['PayerIdentifierNumber'],
        'PayerName': value['PayerName'],
    };
}

